import { render } from "./QueueDetailTableOutboundOverview.vue?vue&type=template&id=94cc15a2"
import script from "./QueueDetailTableOutboundOverview.vue?vue&type=script&lang=js"
export * from "./QueueDetailTableOutboundOverview.vue?vue&type=script&lang=js"

import "./QueueDetailTableOutboundOverview.vue?vue&type=style&index=0&id=94cc15a2&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__